var map = {
	"./menu_AVAL.svg": "803d",
	"./menu_DASHBOARD.svg": "dcc8",
	"./menu_DATAROOM.svg": "b3bf",
	"./menu_DOCL.svg": "c12d",
	"./menu_EVAL.svg": "6378",
	"./menu_EXETR.svg": "0201",
	"./menu_EXIM.svg": "40b5",
	"./menu_HOME.svg": "ccc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78b2";